import React from "react";
import Icons from "@my-dld/assets/icons";

export type IconName = keyof typeof Icons;

export interface AppIconProps {
	name: IconName;
}

export function AppIcon( props: AppIconProps ) {
	const { name } = props;
	const Component = Icons[ name ];
	return <Component/>;
}